import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const OwnerReferralRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const trackReferral = async () => {
      try {
        const res = await axios.get(`${API}/owner-referral/${code}`);
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `ref_owner=${res.data.owner_company_id}; expires=${expires}; path=/`;
        document.cookie = `ref_owner_code=${res.data.referral_code}; expires=${expires}; path=/`;
      } catch (err) {
        // Invalid referral code - redirect silently
      }
      navigate('/', { replace: true });
    };
    trackReferral();
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-[#0A2647] flex items-center justify-center">
      <div className="animate-spin w-8 h-8 border-4 border-[#C5A059] border-t-transparent rounded-full" />
    </div>
  );
};

export default OwnerReferralRedirect;
